import { gql } from 'src/__generated__';

const FETCH_EVENTS = gql(`#graphql
  query FetchEvents($deviceInput: DeviceInput!, $input: MetricsParametersInput, $eventsFilter: EventsFilterInput) {
    device(input: $deviceInput) {
      id
      metrics {
        id
        events(eventsFilter: $eventsFilter, input: $input) {
          data {
            value
            source
            timestamp
            userId
          }
        }
      }
    }
  }
`);

export default FETCH_EVENTS;
